export default __webpack_public_path__ + "static/media/atlantis_logo_white.72012169.png";